module.exports = __webpack_public_path__ + "835ed139b50f47125c562d7409277606.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/bunny.svg
// module id = 80
// module chunks = 0